import FragenBerlin from "./sections/1_fragen/FragenBerlin.svelte";
import FragenExperten from "./sections/1_fragen/FragenExperten.svelte";
import FragenInternational from "./sections/1_fragen/FragenInternational.svelte";
import FragenInformation from "./sections/1_fragen/FragenInformation.svelte";

import Chefs from "./sections/2_chefs/Chefs.svelte";

import ZweiInEiner from "./sections/3_produkt/ZweiInEiner.svelte";

import ProduktNationalInterviews from "./sections/4_produkt_national/ProduktNationalInterviews.svelte";
import ProduktNationalKultur from "./sections/4_produkt_national/ProduktNationalKultur.svelte";
import ProduktNationalPolitik from "./sections/4_produkt_national/ProduktNationalPolitik.svelte";
import ProduktNationalAusblick from "./sections/4_produkt_national/ProduktNationalAusblick.svelte";
import ProduktNationalFachredaktionen from "./sections/4_produkt_national/ProduktNationalFachredaktionen.svelte";

import ProduktBerlinBezirke from "./sections/5_produkt_berlin/ProduktBerlinBezirke.svelte";
import ProduktBerlinPolitik from "./sections/5_produkt_berlin/ProduktBerlinPolitik.svelte";
import ProduktBerlinTagestipps from "./sections/5_produkt_berlin/ProduktBerlinTagestipps.svelte";
import ProduktBerlinUmland from "./sections/5_produkt_berlin/ProduktBerlinUmland.svelte";
import ProduktBerlinWissenschaftWirtschaft from "./sections/5_produkt_berlin/ProduktBerlinWissenschaftWirtschaft.svelte";

import ProduktWochenendeWochenende from "./sections/6_produkt_wochenende/ProduktWochenendeWochenende.svelte";
import ProduktWochenendeSonntag from "./sections/6_produkt_wochenende/ProduktWochenendeSonntag.svelte";
import ProduktWochenendeGenuss from "./sections/6_produkt_wochenende/ProduktWochenendeGenuss.svelte";

import AboTransition from "./sections/7_abo/AboTransition.svelte";
import AboPrint from "./sections/7_abo/AboPrint.svelte";
import AboBestehend from "./sections/7_abo/AboBestehend.svelte";
import AboOnline from "./sections/7_abo/AboOnline.svelte";

import { deepcopy } from "./utils";

const red = "#FFCACA";
const teal = "#CFF2EC";
const yellow = "#FFFBD8";
const purple = "#E0D1EC";
const brown = "#F2E4CF";
const orange = "#FFE7C8";
const grey = "#F2F0EE";

const abolinkHeader =
	"https://abo.tagesspiegel.de/kampagne/der-tagesspiegel-interaktiv?bezuggrd=INT&utm_source=redartikel&utm_medium=artikel&utm_campaign=INT-2023-01-RedArtikel_T20plus-cta-header";
const abolinkAufmacher =
	"https://abo.tagesspiegel.de/kampagne/der-tagesspiegel-interaktiv?bezuggrd=INT&utm_source=redartikel&utm_medium=artikel&utm_campaign=INT-2023-01-RedArtikel_T20plus-cta-aufmacher";
const abolinkChefs =
	"https://abo.tagesspiegel.de/kampagne/der-tagesspiegel-interaktiv?bezuggrd=INT&utm_source=redartikel&utm_medium=artikel&utm_campaign=INT-2023-01-RedArtikel_T20plus-cta-chefredakteure";
const abolinkNachProdukt =
	"https://abo.tagesspiegel.de/kampagne/der-tagesspiegel-interaktiv?bezuggrd=INT&utm_source=redartikel&utm_medium=artikel&utm_campaign=INT-2023-01-RedArtikel_T20plus-cta-nach-produkt";
const abolinkonline =
	"https://abo.tagesspiegel.de/digitalangebote/tplus?bezuggrd=INT&utm_source=redartikel&utm_medium=artikel&utm_campaign=INT-2022-11-29-RedArtikel_T20plus_cta_tsponlineabo";
const faqlink = "https://interaktiv.tagesspiegel.de/lab/alle-fragen-und-antworten-zum-neuen-tagesspiegel/";

export const header = {
	aboText: "ABO",
	aboLink: abolinkHeader,
	ctaButtonText: "30 Tage gratis lesen",
	ctaButtonLink: abolinkHeader,

	tocProdukt: "Übersicht",
	tocProduktId: "produkt_zwei_in_einer",
	tocNational: "Neu im überregionalen Teil",
	tocNationalId: "produkt_national_mehr_politik",
	tocBerlin: "Neu im regionalen Teil",
	tocBerlinId: "produkt_berlin_politik",
	tocWe: "Neu am Wochenende",
	tocWeId: "produkt_wochenende_wochenende",
};

const durationShort = 1600;
const durationMedium = 2000;
const durationLong = 2200;

export const animationLeft = {
	translateX: {
		0: "calc(-100vw - 100%)",
		1: "calc(0vw - 0px)",
	},
	easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
};

export const animationLeft1 = {
	translateX: {
		0: "calc(-100vw - 100%)",
		0.7: "calc(0vw - 0px)",
	},
	easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
};

export const animationLeft2 = {
	translateX: {
		0.15: "calc(-100vw - 100%)",
		0.85: "calc(0vw - 0px)",
	},
	easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
};

export const animationLeft3 = {
	translateX: {
		0.3: "calc(-100vw - 100%)",
		1.0: "calc(0vw - 0px)",
	},
	easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
};

export const animationRight = {
	translateX: {
		0: "calc(100vw + 100%)",
		1.0: "calc(0vw - 0px)",
	},
	easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
};

export const animationRight1 = {
	translateX: {
		0: "calc(100vw + 100%)",
		0.7: "calc(0vw - 0px)",
	},
	easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
};

export const animationRight2 = {
	translateX: {
		0.15: "calc(100vw + 100%)",
		0.85: "calc(0vw - 0px)",
	},
	easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
};

export const animationRight3 = {
	translateX: {
		0.3: "calc(100vw + 100%)",
		1.0: "calc(0vw - 0px)",
	},
	easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
};

export const animationFade = {
	opacity: {
		0: 0,
		1: 1,
	},
	easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
};

export const cover = {
	section: "intro",
	id: "cover",
	animationDuration: 1400,
	props: {
		color: "black",
		content: {
			kicker: "Von Neukölln nach New York",
			title: "Scrollen Sie sich durch den neuen Tagesspiegel",
			ctaButtonText: "30 Tage gratis lesen",
			ctaButtonLink: abolinkAufmacher,
		},
	},
};

export const bildnachweise = {
	section: "outro",
	id: "bildnachweise",
	props: {
		height: "auto",
		maxHeight: "none",
		minHeight: 0,
		content: {
			title: "Bildnachweise",
			attributions: "Porträts: Nassim Rad, Sonstige: Imago, Unsplash",
		},
	},
};

export const slides = [
	// ///////////////////////////////////////////////////////////
	// FEATURES
	// ///////////////////////////////////////////////////////////
	{
		section: "fragen",
		id: "experten",
		props: {
			background: "black",
			//backgroundFixed: "black",
			animationDuration: durationShort,
			color: "white",
			content: {
				kicker: "Was wäre, wenn",
				question: "Sie das Wissen der weltweit führenden Experten gesammelt verfügbar hätten?",
			},
			images: [
				{
					id: "bild_1",
					x: "calc(50% + 1vw + 30px)",
					y: "70px",
					width: "433px",
					anchor: "topleft",
					hideOn: ["mobile", "tablet"],
					responsive: true,
					animation: deepcopy(animationRight1),
				},
				{
					id: "bild_2",
					hideOn: ["mobile", "tablet"],
					x: "50%",
					width: "354px",
					anchor: "topright",
					y: "420px",
					animation: deepcopy(animationLeft2),
				},

				{
					id: "bild_3",
					hideOn: ["mobile", "tablet"],
					x: "100%",
					y: "60%",
					width: "320px",
					anchor: "topright",
					animation: deepcopy(animationRight3),
				},
				//TABLET
				{
					id: "bild_1",
					x: "50vw",
					y: "15%",
					width: "calc(50vw)",
					anchor: "topleft",
					hideOn: ["desktop", "mobile"],
					responsive: true,
					animation: deepcopy(animationRight1),
				},
				{
					id: "bild_2",
					hideOn: ["desktop", "mobile"],
					x: "50%",
					width: "33vw",
					anchor: "topright",
					y: "40%",
					animation: deepcopy(animationLeft2),
				},
				{
					id: "bild_3",
					hideOn: ["desktop", "mobile"],
					x: "calc(50vw - 7px)",
					y: "calc(15% + 50vw*1.3 + 30px)",
					width: "calc(50vw - 60px)",
					anchor: "topleft",
					animation: deepcopy(animationRight3),
				},
				//MOBILE
				{
					id: "bild_1",
					x: "30%",
					y: "27%",
					width: "235px",
					anchor: "topleft",
					hideOn: ["desktop", "tablet"],
					responsive: true,
					animation: deepcopy(animationRight1),
				},
				{
					id: "bild_2",
					hideOn: ["desktop", "tablet"],
					x: "50%",
					width: "200px",
					anchor: "topright",
					y: "57%",
					animation: deepcopy(animationLeft2),
				},
				{
					id: "bild_3",
					hideOn: ["desktop", "tablet"],
					x: "100%",
					y: "82%",
					width: "125px",
					anchor: "bottomright",
					animation: deepcopy(animationRight2),
				},
			],
		},
		component: FragenExperten,
	},
	{
		section: "fragen",
		id: "information",
		props: {
			background: "black",
			color: "white",
			animationDuration: durationShort,
			content: {
				kicker: "Was wäre, wenn",
				question: "Ihre Zeitung mehr Information statt Meinung liefert?",
			},
			images: [
				{
					id: "bild_1",
					hideOn: ["mobile", "tablet"],
					x: "calc(50% - 40px)",
					y: "calc(45% - 40px)",
					width: "400px",
					anchor: "bottomright",
					animation: deepcopy(animationLeft1),
				},
				{
					id: "bild_2",
					hideOn: ["mobile", "tablet"],
					x: "calc(50% - 40px)",
					y: "45%",
					width: "300px",
					anchor: "topright",
					animation: deepcopy(animationLeft2),
				},
				{
					id: "bild_3",
					hideOn: ["mobile", "tablet"],
					x: "50%",
					y: "45%",
					width: "450px",
					anchor: "topleft",
					animation: deepcopy(animationRight2),
				},
				//TABLET
				{
					id: "bild_1",
					hideOn: ["desktop", "mobile"],
					x: "calc(50vw - 30px)",
					y: "20%",
					width: "50vw",
					anchor: "topright",
					animation: deepcopy(animationLeft1),
				},
				{
					id: "bild_2",
					hideOn: ["desktop", "mobile"],
					x: "calc(50vw - 30px)",
					y: "calc(20% + 50vw/1.5 + 30px)",
					width: "27vw",
					anchor: "topright",
					animation: deepcopy(animationLeft3),
				},
				{
					id: "bild_3",
					hideOn: ["desktop", "mobile"],
					x: "50vw",
					y: "40%",
					width: "40vw",
					anchor: "topleft",
					animation: deepcopy(animationRight2),
				},

				//MOBILE
				{
					id: "bild_1",
					hideOn: ["desktop", "tablet"],
					x: "calc(60%)",
					y: "22%",
					width: "280px",
					anchor: "topright",
					animation: deepcopy(animationLeft1),
				},
				{
					id: "bild_2",
					hideOn: ["desktop", "tablet"],
					x: "0",
					y: "calc(22% + 186px + 166px + 40px)",
					width: "200px",
					anchor: "topleft",
					animation: deepcopy(animationLeft3),
				},
				{
					id: "bild_3",
					hideOn: ["desktop", "tablet"],
					x: "40%",
					y: "calc(22% + 186px + 20px)",
					width: "250px",
					anchor: "topleft",
					animation: deepcopy(animationRight2),
				},
			],
		},
		component: FragenInformation,
	},
	{
		section: "fragen",
		id: "international",
		props: {
			height: "120vh",
			background: "black",
			backgroundFixed: "black",
			animationDuration: durationShort,
			color: "white",
			content: {
				kicker: "Was wäre, wenn",
				question: "Internationale Berichterstattung täglich auch abseits von Krisen stattfände?",
			},
			images: [
				{
					id: "bild_1",
					hideOn: ["mobile", "tablet"],
					x: "calc(75% - 40px)",
					y: "40px",
					width: "329px",
					anchor: "topright",
					animation: deepcopy(animationRight1),
				},
				{
					id: "bild_2",
					hideOn: ["mobile", "tablet"],
					x: "75%",
					y: "calc(220px)",
					width: "300px",
					anchor: "topleft",
					animation: deepcopy(animationRight2),
				},
				{
					id: "bild_3",
					hideOn: ["mobile", "tablet"],
					x: "calc(75% - 40px)",
					y: "calc(475px + 120px)",
					width: "500px",
					anchor: "topright",
					animation: deepcopy(animationLeft3),
				},
				//TABLET
				{
					id: "bild_1",
					hideOn: ["desktop", "mobile"],
					x: "100%",
					y: "10%",
					width: "35vw",
					anchor: "topright",
					animation: deepcopy(animationRight1),
				},
				{
					id: "bild_2",
					hideOn: ["desktop", "mobile"],
					x: "50%",
					y: "calc(10% + 35vw * 1.25 + 30px)",
					width: "35vw",
					anchor: "topleft",
					animation: deepcopy(animationRight3),
				},
				{
					id: "bild_3",
					hideOn: ["desktop", "mobile"],
					x: "calc(50vw - 60px)",
					y: "40%",
					width: "50vw",
					anchor: "topright",
					animation: deepcopy(animationLeft2),
				},
				//MOBILE
				{
					id: "bild_1",
					hideOn: ["desktop", "tablet"],
					x: "100%",
					y: "415px",
					width: "calc(50vw - 23px)",
					anchor: "bottomright",
					animation: deepcopy(animationRight1),
				},
				{
					id: "bild_2",
					hideOn: ["desktop", "tablet"],
					x: "0",
					y: "calc(415px + 15px)",
					width: "calc(75vw - 23px)",
					anchor: "topleft",
					animation: deepcopy(animationLeft2),
				},
				{
					id: "bild_3",
					hideOn: ["desktop", "tablet"],
					x: "0",
					y: "415px",
					width: "calc(50vw - 23px)",
					anchor: "bottomleft",
					animation: deepcopy(animationLeft1),
				},
			],
		},
		component: FragenInternational,
	},
	{
		section: "fragen",
		id: "berlin",
		props: {
			height: "120vh",
			background: "black",
			backgroundFixed: "black",
			color: "white",
			animationDuration: durationShort,
			content: {
				kicker: "Was wäre, wenn",
				question: "Sie Berlin so gut verstehen könnten wie nie zuvor?",
			},
			images: [
				{
					id: "bild_1",
					hideOn: ["mobile", "tablet"],
					x: "60%",
					y: "280px",
					width: "433px",
					anchor: "topright",
					animation: deepcopy(animationRight2),
				},
				{
					id: "bild_2",
					hideOn: ["mobile", "tablet"],
					x: "0%",
					y: "0px",
					width: "364px",
					anchor: "topleft",
					animation: deepcopy(animationLeft1),
				},
				{
					id: "bild_3",
					hideOn: ["mobile", "tablet"],
					x: "40%",
					y: "calc(10% + 520px)",
					width: "353px",
					anchor: "topright",
					animation: deepcopy(animationLeft3),
				},
				//TABLET
				{
					id: "bild_1",
					hideOn: ["desktop", "mobile"],
					x: "50vw",
					y: "20%",
					width: "50vw",
					anchor: "topleft",
					animation: deepcopy(animationRight2),
				},
				{
					id: "bild_2",
					hideOn: ["desktop", "mobile"],
					x: "50%",
					y: "0",
					width: "calc(50vw - 30px)",
					anchor: "topright",
					animation: deepcopy(animationLeft1),
				},
				{
					id: "bild_3",
					hideOn: ["desktop", "mobile"],
					x: "0%",
					y: "calc(20% + 50vw / 1.5 + 30px)",
					width: "65vw",
					anchor: "topleft",
					animation: deepcopy(animationLeft3),
				},

				//MOBILE
				{
					id: "bild_1",
					hideOn: ["desktop", "tablet"],
					x: "0",
					y: "16%",
					width: "calc(75vw - 23px)",
					anchor: "topleft",
					animation: deepcopy(animationLeft1),
				},
				{
					id: "bild_2",
					hideOn: ["desktop", "tablet"],
					x: "27%",
					y: "calc(16% + 70vw / 1.5 + 15px)",
					width: "calc(75vw - 23px)",
					anchor: "topleft",
					animation: deepcopy(animationRight),
				},
				{
					id: "bild_3",
					hideOn: ["desktop", "tablet"],
					x: "calc(75vw - 23px)",
					y: "calc(16% + 70vw * 1.35 + 25px)",
					width: "353px",
					anchor: "topright",
					animation: deepcopy(animationLeft3),
				},
			],
		},
		component: FragenBerlin,
	},
	// ///////////////////////////////////////////////////////////
	// EDITORS IN CHIEF
	// ///////////////////////////////////////////////////////////
	{
		section: "chefs",
		id: "chefs",
		props: {
			backgroundFixed: "white",
			background: red,
			width: "100vw",
			maxWidth: "100vw",
			animationDuration: durationShort,
			content: {
				quote: "„Wir haben Ihnen zugehört – und eine Zeitung geschaffen, die all das vereint.“",
				names: "Lorenz Maroldt und Christian Tretbar,<br>Chefredakteure",
				button_text: "30 Tage gratis lesen",
				button_link: abolinkChefs,
			},
			images: [
				{
					id: "lorenz",
					x: "47%",
					y: "100%",
					height: "430px",
					anchor: "bottomright",
					hideOn: ["mobile"],
				},
				{
					id: "christian",
					x: "53%",
					y: "100%",
					height: "430px",
					anchor: "bottomleft",
					hideOn: ["mobile"],
				},
				// mobile
				{
					id: "lorenz",
					x: "57%",
					y: "100%",
					height: "265px",
					anchor: "bottomright",
					hideOn: ["desktop", "tablet"],
				},
				{
					id: "christian",
					x: "47%",
					y: "100%",
					height: "265px",
					anchor: "bottomleft",
					hideOn: ["desktop", "tablet"],
				},
			],

			imagesBg: [
				{
					id: "bg_left_desktop",
					x: "0",
					y: "100%",
					height: "74vh",
					anchor: "bottom left",
					animation: {
						translateX: { 0: "-300px", 1: "0px" },
						opacity: { 0: 0, 1: 1 },
					},
					hideOn: ["mobile", "tablet"],
				},
				{
					id: "bg_right_desktop",
					x: "100%",
					y: "100%",
					height: "74vh",
					anchor: "bottom right",
					animation: {
						translateX: { 0: "300px", 1: "0px" },
						opacity: { 0: 0, 1: 1 },
					},
					hideOn: ["mobile", "tablet"],
				},
				// {
				// 	id: "bg_mobile_tablet",
				// 	x: "50%",
				// 	y: "100%",
				// 	height: "50vh",
				// 	anchor: "bottom",
				// 	animation: {
				// 		translateY: { 0: "50%", 0.8: "0%" },
				// 		opacity: { 0: 0, 1: 1 },
				// 	},
				// 	hideOn: ["desktop", "mobile"],
				// },
				// {
				// 	id: "bg_mobile_tablet",
				// 	x: "50%",
				// 	y: "100%",
				// 	height: "40vh",
				// 	anchor: "bottom",
				// 	animation: {
				// 		translateY: { 0: "50%", 0.8: "0%" },
				// 		opacity: { 0: 0, 1: 1 },
				// 	},
				// 	hideOn: ["desktop", "tablet"],
				// },
			],
		},
		component: Chefs,
	},
	// ///////////////////////////////////////////////////////////
	// PRODUKT
	// ///////////////////////////////////////////////////////////
	{
		section: "produkt",
		id: "zwei_in_einer",
		props: {
			background: red,
			content: {
				heading: "<b>Zwei Zeitungen</b><br><b>in einer</b>",
				text: "Der Tagesspiegel erscheint in neuem Format – perfekt für den Küchentisch oder unterwegs. Er hat mehr Inhalt, ist aber einfacher zu lesen – durch ein neues aufgeräumtes Design. Überregionaler Teil und Berlin-Teil sind klar voneinander getrennt.",
				num_international: "40",
				text_international: "Seiten aus<br>der Welt",
				num_berlin: "40",
				text_berlin: "Seiten aus<br>der Weltstadt",
			},
			pages: [
				{
					id: "seite_1",
					x: "50%",
					y: "54%",
					width: "300px",
					anchor: "top",
					animation: {
						translateX: {
							0.3: "0px",
							1: "-180px",
						},
						easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
					},
					hideOn: ["mobile"],
				},
				{
					id: "seite_2",
					x: "50%",
					y: "54%",
					width: "300px",
					anchor: "top",
					animation: {
						translateX: {
							0.3: "0px",
							1: "180px",
						},
						easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
					},
					hideOn: ["mobile"],
				},
				// mobile
				{
					id: "seite_1",
					x: "0%",
					y: "90%",
					width: "calc(50vw - 23px)",
					anchor: "bottomleft",
					animation: {
						translateX: {
							0.3: "50%",
							1: "0px",
						},
						easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
					},
					hideOn: ["desktop", "tablet"],
				},
				{
					id: "seite_2",
					x: "100%",
					y: "90%",
					width: "calc(50vw - 23px)",
					anchor: "bottomright",
					animation: {
						translateX: {
							0.3: "-50%",
							1: "0px",
						},
						easing: "cubic-bezier(0.585, -0.010, 0.070, 1.000)",
					},
					hideOn: ["desktop", "tablet"],
				},
			],
		},
		component: ZweiInEiner,
	},
	// ///////////////////////////////////////////////////////////
	// PRODUKT NATIONAL
	// ///////////////////////////////////////////////////////////
	{
		section: "produkt_national",
		id: "mehr_politik",
		props: {
			animationDuration: durationShort,
			background: teal,
			content: {
				heading: "<b>Mehr Politik</b><br>aus aller Welt",
				text: "Der Politikteil ist vollständig neu gestaltet: Die starke bundespolitische Bericht&shy;erstattung wird ausgebaut. Zusätzlich bekommt internationale Politik deutlich mehr Gewicht. Expertinnen und Experten aus aller Welt analysieren regelmäßig internationale Entwicklungen.",
				fact_num: "1000+",
				fact_text: "Expertinnen und Experten in <br> unserem globalen Netzwerk",
			},
			pages: [
				{
					id: "seite_1",
					x: "100%",
					y: "80px",
					width: "325px",
					anchor: "topright",
					animation: deepcopy(animationRight1),
					hideOn: ["mobile", "tablet"],
				},
				{
					id: "seite_2",
					x: "100%",
					y: "calc(70px + 228px + 45px)",
					width: "480px",
					anchor: "topright",
					animation: deepcopy(animationRight2),
					hideOn: ["mobile", "tablet"],
				},
				{
					id: "seite_3",
					x: "50%",
					y: "calc(70px + 228px + 336px + 80px)",
					width: "325px",
					anchor: "topleft",
					animation: deepcopy(animationRight3),
					hideOn: ["mobile", "tablet"],
				},
				// tablet
				{
					id: "seite_1",
					x: "115%",
					y: "calc(98% - 45vw / 1.425 - 30px - calc(80vw - 6vh) / 1.425 - 30px)",
					width: "45vw",
					anchor: "bottomright",
					animation: deepcopy(animationRight1),
					hideOn: ["desktop", "mobile"],
				},
				{
					id: "seite_2",
					x: "50%",
					y: "calc(98% - 45vw / 1.425 - 30px)",
					width: "calc(80vw - 6vh)",
					anchor: "bottomcenter",
					animation: deepcopy(animationRight2),
					hideOn: ["desktop", "mobile"],
				},
				{
					id: "seite_3",
					x: "0%",
					y: "98%",
					width: "45vw",
					anchor: "bottomleft",
					animation: deepcopy(animationRight3),
					hideOn: ["desktop", "mobile"],
				},
				// mobile
				{
					id: "seite_1",
					x: "0%",
					y: "calc(80% + 15px)",
					width: "calc(50vw - 23px)",
					anchor: "topleft",
					animation: deepcopy(animationLeft2),
					hideOn: ["desktop", "tablet"],
				},
				{
					id: "seite_2",
					x: "50%",
					y: "80%",
					width: "calc(100vw - 30px)",
					anchor: "bottom",
					animation: deepcopy(animationLeft1),
					hideOn: ["desktop", "tablet"],
				},
				{
					id: "seite_3",
					x: "100%",
					y: "calc(80% + 15px)",
					width: "calc(50vw - 23px)",
					anchor: "topright",
					animation: deepcopy(animationRight2),
					hideOn: ["desktop", "tablet"],
				},
			],
			illustrations: [
				{
					id: "illu_1",
					x: "140%",
					y: "35%",
					width: "1057px",
					anchor: "topright",
					animation: deepcopy(animationFade),
					hideOn: ["mobile", "tablet"],
				},
				// tablet
				{
					id: "illu_1",
					x: "110%",
					y: "90%",
					width: "80vw",
					anchor: "bottomright",
					animation: deepcopy(animationFade),
					hideOn: ["desktop", "mobile"],
				},
				// mobile
				{
					id: "illu_1",
					x: "120%",
					y: "calc(68% - 50vw)",
					width: "80vw",
					anchor: "topright",
					animation: deepcopy(animationFade),
					hideOn: ["desktop", "tablet"],
				},
			],
		},
		component: ProduktNationalPolitik,
	},
	{
		section: "produkt_national",
		id: "fachredaktionen",
		props: {
			animationDuration: durationShort,
			background: yellow,
			content: {
				heading: "<b>Mehr Wissens&shy;vorsprung</b><br> in Wirtschaft und Forschung",
				text: "Der Tagesspiegel präsentiert Ihnen die wichtigsten Analysen und Hintergründe aus unseren Fachredaktionen, den Backgrounds, und dem Handelsblatt – unter anderem zu Klimapolitik, Digital&shy;isierung und Mobilität – aber auch zu Märkten und Unternehmen.",
				text_coop: "in Kooperation mit dem",
			},
			pages: [
				{
					id: "seite_1",
					x: "0",
					y: "40px",
					width: "calc(1200px * 0.6 - 40px)",
					anchor: "topleft",
					animation: deepcopy(animationLeft1),
					hideOn: ["mobile", "tablet"],
				},
				// tablet
				{
					id: "seite_1",
					x: "50%",
					y: "600px",
					width: "calc(100vw - 60px)",
					anchor: "top",
					animation: deepcopy(animationRight),
					hideOn: ["desktop", "mobile"],
				},
				// mobile
				{
					id: "seite_1",
					x: "50%",
					y: "calc(650px + 4vh)",
					width: "calc(100vw - 30px)",
					anchor: "bottom",
					animation: deepcopy(animationRight),
					hideOn: ["desktop", "tablet"],
				},
			],
		},
		component: ProduktNationalFachredaktionen,
	},
	{
		section: "produkt_national",
		id: "interviews",
		props: {
			animationDuration: durationMedium,
			background: red,
			content: {
				heading: "<b>Mehr Interviews</b><br> mit den klügsten Köpfen",
				text: "Herausragende Persönlichkeiten des öffentlichen Lebens im intensiven Gespräch – jeden Tag auf einer Doppelseite.",
				fact_num: "7",
				fact_text: "Tage pro Woche<br>exklusive Interviews",
			},
			pages: [
				{
					id: "seite_1",
					x: "0%",
					y: "560px",
					width: "1196px",
					anchor: "topleft",
					animation: deepcopy(animationRight3),
					hideOn: ["mobile", "tablet"],
				},
				// tablet
				{
					id: "seite_1",
					x: "50%",
					y: "450px",
					width: "calc(100vw - 60px)",
					anchor: "top",
					animation: deepcopy(animationRight2),
					hideOn: ["desktop", "mobile"],
				},
				// mobile
				{
					id: "seite_1",
					x: "0%",
					y: "98%",
					width: "calc(100vw - 30px)",
					anchor: "bottomleft",
					animation: deepcopy(animationRight2),
					hideOn: ["desktop", "tablet"],
				},
			],
		},
		component: ProduktNationalInterviews,
	},
	{
		section: "produkt_national",
		id: "kultur",
		props: {
			animationDuration: durationMedium,
			background: brown,
			content: {
				heading: "<b>Mehr Kultur</b><br> aus Berlin, Deutschland und der Welt",
				text: "Wir berichten über die wichtigsten nationalen und internationalen Ausstell&shy;ungen, Filme, Bücher und Ereignisse. Dazu gibt es jeden Tag alles zur Kultur in Berlin.",
				fact_num: "2",
				fact_text: "Kulturteile – ein regionaler,<br>ein überregionaler",
			},
			pages: [
				{
					id: "seite_1",
					x: "0",
					y: "110px",
					width: "600px",
					anchor: "topleft",
					animation: deepcopy(animationLeft1),
					hideOn: ["mobile", "tablet"],
				},
				{
					id: "seite_2",
					x: "100%",
					y: "535px",
					width: "560px",
					anchor: "topright",
					animation: deepcopy(animationRight2),
					hideOn: ["mobile", "tablet"],
				},
				// tablet
				{
					id: "seite_1",
					x: "0%",
					y: "calc(98% - 60vw / 1.425 - 30px)",
					width: "60vw",
					anchor: "bottomleft",
					animation: deepcopy(animationLeft1),
					hideOn: ["desktop", "mobile"],
				},
				{
					id: "seite_2",
					x: "100%",
					y: "98%",
					width: "60vw",
					anchor: "bottomright",
					animation: deepcopy(animationRight2),
					hideOn: ["desktop", "mobile"],
				},
				// mobile
				{
					id: "seite_1",
					x: "0%",
					y: "74%",
					width: "calc(100vw - 30px)",
					anchor: "bottomleft",
					animation: deepcopy(animationRight1),
					hideOn: ["desktop", "tablet"],
				},
				{
					id: "seite_2",
					x: "0%",
					y: "96%",
					width: "calc(60vw)",
					anchor: "bottomleft",
					animation: deepcopy(animationLeft2),
					hideOn: ["desktop", "tablet"],
				},
			],
		},
		component: ProduktNationalKultur,
	},
	{
		section: "produkt_national",
		id: "ausblick",
		props: {
			background: purple,
			animationDuration: durationShort,
			content: {
				heading: "<b>Mehr Ausblick</b><br> auf die Fragen von morgen",
				text: "Niemand möchte erst über Ereignisse erfahren, wenn sie schon vorbei sind. Auf der letzten Seite geben daher täglich drei Expertinnen und Experten ihre Ein&shy;schätzung zu einer Frage, die morgen wichtig wird.",
				fact_num: "3",
				fact_text: "wechselnde Experten<br>beantworten eine Frage",
			},
			pages: [
				{
					id: "seite_1",
					x: "100%",
					y: "110px",
					width: "600px",
					anchor: "topright",
					animation: deepcopy(animationRight),
					hideOn: ["mobile", "tablet"],
					type: "single",
				},
				// tablet
				{
					id: "seite_1",
					x: "100%",
					y: "98%",
					width: "58vw",
					anchor: "bottomright",
					animation: deepcopy(animationRight),
					hideOn: ["desktop", "mobile"],
					type: "single",
				},
				// mobile
				{
					id: "seite_1",
					x: "50%",
					y: "98%",
					width: "calc(30vw + 23vh)",
					anchor: "bottom",
					animation: deepcopy(animationLeft),
					hideOn: ["desktop", "tablet"],
					type: "single",
				},
			],
		},
		component: ProduktNationalAusblick,
	},
	// ///////////////////////////////////////////////////////////
	// PRODUKT BERLIN
	// ///////////////////////////////////////////////////////////
	{
		section: "produkt_berlin",
		id: "politik",
		props: {
			background: red,
			animationDuration: durationMedium,
			content: {
				heading: "<b>Mehr Berlin-Politik</b><br> Deutschland hat eine neue Zeitung, Berlin auch",
				text: "Keine andere Zeitung berichtet so intensiv über die Politik der Hauptstadt. Das bauen wir weiter aus.",
				fact_num: "147",
				fact_text: "Abgeordnetenhauspolitiker<br>unter Beobachtung",
			},
			pages: [
				{
					id: "seite_1",
					x: "100%",
					y: "110px",
					width: "597px",
					anchor: "topright",
					animation: deepcopy(animationRight1),
					hideOn: ["mobile", "tablet"],
				},
				{
					id: "seite_2",
					x: "25%",
					y: "570px",
					width: "718px",
					anchor: "topleft",
					animation: deepcopy(animationLeft2),
					hideOn: ["mobile", "tablet"],
				},
				// tablet
				{
					id: "seite_1",
					x: "108%",
					y: "560px",
					width: "56vw",
					anchor: "topright",
					animation: deepcopy(animationRight1),
					hideOn: ["desktop", "mobile"],
				},
				{
					id: "seite_2",
					x: "0%",
					y: "calc(56vw / 1.425 + 590px)",
					width: "56vw",
					anchor: "topleft",
					animation: deepcopy(animationLeft2),
					hideOn: ["desktop", "mobile"],
				},
				// mobile
				{
					id: "seite_1",
					x: "50%",
					y: "calc(98% - (100vw - 30px) / 1.425 - 2%)",
					width: "calc(100vw - 30px)",
					anchor: "bottom",
					animation: deepcopy(animationLeft1),
					hideOn: ["desktop", "tablet"],
				},
				{
					id: "seite_2",
					x: "50%",
					y: "98%",
					width: "calc(100vw - 30px)",
					anchor: "bottom",
					animation: deepcopy(animationRight2),
					hideOn: ["desktop", "tablet"],
				},
			],
		},
		component: ProduktBerlinPolitik,
	},
	{
		section: "produkt_berlin",
		id: "bezirke",
		props: {
			background: yellow,
			animationDuration: durationMedium,
			content: {
				heading: "<b>Mehr Kiez</b><br> mit Bericht&shy;erstattung aus allen Bezirken",
				text: "Unsere Bezirke-Redaktion hat Leute in jedem Teil der Stadt. Sie berichten wöchentlich in lokalen Newslettern – und nun auch regelmäßig in der Zeitung.",
				fact_num: "12",
				fact_text: "Bezirke, <br> 12 Newsletter, 2 Seiten",
			},
			pages: [
				{
					id: "seite_1",
					x: "0%",
					y: "115px",
					width: "760px",
					anchor: "topleft",
					animation: deepcopy(animationLeft1),
					hideOn: ["mobile", "tablet"],
				},
				// tablet
				{
					id: "seite_1",
					x: "0%",
					y: "520px",
					width: "70vw",
					anchor: "topleft",
					animation: deepcopy(animationLeft1),
					hideOn: ["desktop", "mobile"],
				},
				// mobile
				{
					id: "seite_1",
					x: "0",
					y: "93%",
					width: "calc(60vh + 65px)",
					anchor: "bottomleft",
					animation: deepcopy(animationLeft),
					hideOn: ["desktop", "tablet"],
				},
			],
			images: [
				{
					id: "ipad",
					x: "50%",
					y: "50%",
					width: "320px",
					anchor: "topleft",
					animation: deepcopy(animationRight2),
					hideOn: ["mobile", "tablet"],
				},
				// tablet
				{
					id: "ipad",
					x: "100%",
					y: "700px",
					width: "calc(16vw + 18vh)",
					anchor: "topright",
					animation: deepcopy(animationRight2),
					hideOn: ["desktop", "mobile"],
				},
			],
		},
		component: ProduktBerlinBezirke,
	},
	{
		section: "produkt_berlin",
		id: "umland",
		props: {
			background: teal,
			animationDuration: durationShort,
			content: {
				heading: "<b>Mehr Umland</b><br> mit allem Wichtigen aus der Region",
				text: "Berlin boomt wie kaum eine andere Gegend Europas. Brandenburg bekommt mehr Gewicht in unserer Bericht&shy;erstattung. Für Ausflugs&shy;tipps genauso wie Politik und Immobilien.",
				fact_num: "4",
				fact_text: "Seiten für<br>Brandenburg",
			},
			pages: [
				{
					id: "seite_1",
					x: "100%",
					y: "98%",
					width: "calc(40vw + 150px)",
					maxWidth: "1000px",
					anchor: "bottomright",
					animation: deepcopy(animationRight),
					hideOn: ["mobile", "tablet"],
				},
				// tablet
				{
					id: "seite_1",
					x: "50%",
					y: "98%",
					width: "calc(100vw - 60px)",
					anchor: "bottom",
					animation: deepcopy(animationRight),
					hideOn: ["desktop", "mobile"],
				},
				// mobile
				{
					id: "seite_1",
					x: "0%",
					y: "96%",
					width: "calc(60vh + 60px)",
					anchor: "bottomleft",
					animation: deepcopy(animationRight),
					hideOn: ["desktop", "tablet"],
				},
			],
		},
		component: ProduktBerlinUmland,
	},
	{
		section: "produkt_berlin",
		id: "wissenschaft_wirtschaft",
		props: {
			background: brown,
			animationDuration: durationLong,
			content: {
				heading: "<b>Mehr Wirtschaft,<br>Wissenschaft, Kultur & Sport aus Berlin</b>",
				text: "Künftig gibt es im Berlinteil der Zeitung täglich eigene Ressorts für Wirtschaft, Kultur, Wissenschaft und Sport in Berlin und Brandenburg.",
				fact_num: "4",
				fact_text: "neue Ressorts<br>für Berlin",
			},
			pages: [
				{
					id: "seite_1",
					x: "50%",
					y: "110px",
					width: "600px",
					anchor: "topleft",
					animation: deepcopy(animationRight1),
					hideOn: ["mobile", "tablet"],
				},
				{
					id: "seite_2",
					x: "calc(50% - 40px)",
					y: "55%",
					width: "450px",
					anchor: "topright",
					animation: deepcopy(animationLeft2),
					hideOn: ["mobile", "tablet"],
				},
				{
					id: "seite_3",
					x: "50%",
					y: "90%",
					width: "450px",
					anchor: "bottomleft",
					animation: deepcopy(animationRight3),
					hideOn: ["mobile", "tablet"],
				},
				// tablet
				{
					id: "seite_1",
					x: "0%",
					y: "calc(98% - 45vw / 1.425 - 30px - 50vw / 1.425 - 30px)",
					width: "65vw",
					anchor: "bottomleft",
					animation: deepcopy(animationLeft1),
					hideOn: ["desktop", "mobile"],
				},
				{
					id: "seite_2",
					x: "100%",
					y: "calc(98% - 45vw / 1.425 - 30px)",
					width: "50vw",
					anchor: "bottomright",
					animation: deepcopy(animationRight2),
					hideOn: ["desktop", "mobile"],
				},
				{
					id: "seite_3",
					x: "0%",
					y: "98%",
					width: "45vw",
					anchor: "bottomleft",
					animation: deepcopy(animationLeft3),
					hideOn: ["desktop", "mobile"],
				},
				// mobile
				{
					id: "seite_1",
					x: "120%",
					y: "36%",
					width: "calc(28vw + 200px)",
					anchor: "topright",
					animation: deepcopy(animationRight1),
					hideOn: ["desktop", "tablet"],
				},
				{
					id: "seite_2",
					x: "0%",
					y: "67%",
					width: "calc(28vw + 130px)",
					anchor: "centerleft",
					animation: deepcopy(animationLeft2),
					hideOn: ["desktop", "tablet"],
				},
				{
					id: "seite_3",
					x: "110%",
					y: "93%",
					width: "calc(28vw + 130px)",
					anchor: "bottomright",
					animation: deepcopy(animationRight3),
					hideOn: ["desktop", "tablet"],
				},
			],
		},
		component: ProduktBerlinWissenschaftWirtschaft,
	},
	{
		section: "produkt_berlin",
		id: "tagestipps",
		props: {
			background: red,
			animationDuration: durationMedium,
			content: {
				heading: "<b>Mehr Stadt</b><br> Ihr Begleiter<br>durch den Tag",
				text: "Ob neue Filme, Ausstellungen, Konzerte oder Festivals. Unsere Tagestipps fassen täglich alle wichtigen zusammen.",
				fact_num: "365",
				fact_text: "Tage im Jahr wissen,<br>was in Berlin läuft",
			},
			pages: [
				{
					id: "seite_1",
					x: "50%",
					y: "110px",
					width: "600px",
					anchor: "topleft",
					animation: deepcopy(animationRight1),
					hideOn: ["mobile", "tablet"],
				},
				{
					id: "seite_2",
					x: "0%",
					y: "600px",
					width: "600px",
					anchor: "topleft",
					animation: deepcopy(animationLeft2),
					hideOn: ["mobile", "tablet"],
				},
				// tablet
				{
					id: "seite_1",
					x: "100%",
					y: "calc(98% - 70vw / 1.425 - 30px)",
					width: "70vw",
					anchor: "bottomright",
					animation: deepcopy(animationRight1),
					hideOn: ["desktop", "mobile"],
				},
				{
					id: "seite_2",
					x: "0%",
					y: "98%",
					width: "70vw",
					anchor: "bottomleft",
					animation: deepcopy(animationLeft2),
					hideOn: ["desktop", "mobile"],
				},
				// mobile
				{
					id: "seite_1",
					x: "50%",
					y: "66%",
					width: "calc(100vw - 30px)",
					anchor: "bottom",
					animation: deepcopy(animationRight1),
					hideOn: ["tablet", "desktop"],
				},
				{
					id: "seite_2",
					x: "130%",
					y: "calc(66% + 20px",
					width: "calc(100vw - 30px)",
					anchor: "topright",
					animation: deepcopy(animationRight2),
					hideOn: ["tablet", "desktop"],
				},
			],
		},
		component: ProduktBerlinTagestipps,
	},
	// ///////////////////////////////////////////////////////////
	// WOCHENENDE
	// ///////////////////////////////////////////////////////////
	{
		section: "produkt_wochenende",
		id: "wochenende",
		props: {
			background: teal,
			animationDuration: durationLong,
			content: {
				heading: "<b>Mehr Wochenende</b><br> mit Lesestücken und Orientierungshilfen",
				text: "Samstag gibt es einen dritten Zeitungsteil, der Ihnen viel Nutzwert liefert – zu Immobilien, Finanzen, Job & Karriere sowie Reise und Mobilität.",
				fact_num: "32",
				fact_text: "Seiten zusätzlich <br> am Samstag",
			},
			pages: [
				{
					id: "seite_1",
					x: "calc(50% - 40px)",
					y: "80px",
					width: "300px",
					anchor: "topright",
					animation: deepcopy(animationLeft1),
					type: "single",
					hideOn: ["mobile", "tablet"],
				},
				{
					id: "seite_2",
					x: "calc(50% - 40px)",
					y: "540px",
					width: "600px",
					anchor: "topright",
					animation: deepcopy(animationLeft3),
					hideOn: ["mobile", "tablet"],
				},
				{
					id: "seite_3",
					x: "50%",
					y: "40%",
					width: "600px",
					anchor: "topleft",
					animation: deepcopy(animationRight2),
					hideOn: ["mobile", "tablet"],
				},
				// tablet
				{
					id: "seite_1",
					x: "calc(50% - 15px)",
					y: "calc(98% - 50vw / 1.425 - 30px)",
					// width: "calc(50vw - 30px - 15px)",
					width: "calc(18vw + 15vh - 30px - 15px)",
					anchor: "bottomright",
					animation: deepcopy(animationLeft1),
					type: "single",
					hideOn: ["desktop", "mobile"],
				},
				{
					id: "seite_2",
					x: "calc(50% + 15px)",
					y: "calc(98% - 50vw / 1.425 - 30px)",
					width: "calc(32vw + 15vh)",
					anchor: "bottomleft",
					animation: deepcopy(animationRight2),
					hideOn: ["desktop", "mobile"],
				},
				{
					id: "seite_3",
					x: "60%",
					y: "98%",
					width: "50vw",
					anchor: "bottom",
					animation: deepcopy(animationRight1),
					hideOn: ["desktop", "mobile"],
				},
				// mobile
				{
					id: "seite_1",
					x: "63%",
					y: "63%",
					width: "calc(20vw + 10vh)",
					anchor: "bottomright",
					animation: deepcopy(animationLeft1),
					type: "single",
					hideOn: ["desktop", "tablet"],
				},
				{
					id: "seite_2",
					x: "66%",
					y: "72%",
					width: "calc(32vw + 15vh)",
					anchor: "bottomleft",
					animation: deepcopy(animationRight2),
					hideOn: ["desktop", "tablet"],
				},
				{
					id: "seite_3",
					x: "63%",
					y: "64%",
					width: "calc(28vw + 25vh)",
					anchor: "topright",
					animation: deepcopy(animationLeft3),
					hideOn: ["desktop", "tablet"],
				},
			],
		},
		component: ProduktWochenendeWochenende,
	},
	{
		section: "produkt_wochenende",
		id: "sonntag",
		props: {
			background: purple,
			animationDuration: durationMedium,
			content: {
				heading: "<b>Mehr Sonntagsgefühl</b><br>mit Essays, Debatten und Recherchen",
				text: "Sonntags gibt es Schwerpunkt&shy;seiten zu Gesellschaft, Debatten – und besonderen Recherchen.",
				fact_num: "8",
				fact_text: "Seiten Gesellschaft und<br>Debatte am Sonntag",
				transition_text: "Konnten wir Sie neugierig machen?<br><b>Dann testen Sie uns gratis!</b>",
			},
			pages: [
				{
					id: "seite_1",
					x: "100%",
					y: "110px",
					width: "597px",
					anchor: "topright",
					animation: deepcopy(animationRight1),
					hideOn: ["mobile", "tablet"],
				},
				{
					id: "seite_2",
					x: "25%",
					y: "570px",
					width: "718px",
					anchor: "topleft",
					animation: deepcopy(animationLeft2),
					hideOn: ["mobile", "tablet"],
				},
				// tablet
				{
					id: "seite_1",
					x: "108%",
					y: "460px",
					width: "56vw",
					anchor: "topright",
					animation: deepcopy(animationRight1),
					hideOn: ["desktop", "mobile"],
				},
				{
					id: "seite_2",
					x: "0%",
					y: "calc(56vw / 1.425 + 490px)",
					width: "56vw",
					anchor: "topleft",
					animation: deepcopy(animationLeft2),
					hideOn: ["desktop", "mobile"],
				},
				// mobile
				{
					id: "seite_1",
					x: "50%",
					y: "calc(98% - (100vw - 30px) / 1.425 - 2%)",
					width: "calc(100vw - 30px)",
					anchor: "bottom",
					animation: deepcopy(animationLeft1),
					hideOn: ["desktop", "tablet"],
				},
				{
					id: "seite_2",
					x: "50%",
					y: "98%",
					width: "calc(100vw - 30px)",
					anchor: "bottom",
					animation: deepcopy(animationRight2),
					hideOn: ["desktop", "tablet"],
				},
			],
		},
		component: ProduktWochenendeSonntag,
	},
	{
		section: "produkt_wochenende",
		id: "genuss",
		props: {
			background: orange,
			animationDuration: durationShort,
			content: {
				heading: "<b>Mehr Genuss</b><br> im Restaurant oder Ihrer Küche",
				text: "Unsere Gastrokritiker wissen, welche neuen Restaurants sich lohnen, welche kulinarischen Entwicklungen Sie kennen sollten – und welche Lebens&shy;mittel&shy;geschäfte die besten Produkte verkaufen.",
				fact_num: "500",
				fact_text: "Restaurants besucht unsere<br>Genussredaktion jährlich mindestens",
			},
			pages: [
				{
					id: "seite_1",
					x: "0%",
					y: "620px",
					width: "1200px",
					anchor: "topleft",
					animation: deepcopy(animationLeft),
					hideOn: ["mobile", "tablet"],
					fadeToTransparent: true,
				},
				// tablet
				{
					id: "seite_1",
					x: "0",
					y: "550px",
					width: "100%",
					anchor: "topleft",
					animation: deepcopy(animationRight),
					hideOn: ["mobile", "desktop"],
					fadeToTransparent: true,
				},
				// mobile
				{
					id: "seite_1",
					x: "0%",
					y: "60%",
					width: "calc(100vw - 30px)",
					anchor: "topleft",
					animation: deepcopy(animationRight),
					hideOn: ["tablet", "desktop"],
					fadeToTransparent: true,
				},
			],
		},
		component: ProduktWochenendeGenuss,
	},
	// ///////////////////////////////////////////////////////////
	// ABO
	// ///////////////////////////////////////////////////////////
	{
		section: "abo",
		id: "transition",
		hideFor: ["subscribers"],
		props: {
			height: "auto",
			maxHeight: "none",
			minHeight: "0",
			background: orange,
			content: {
				heading: "Konnten wir Sie neugierig machen?<br><b>Dann testen Sie uns gratis!</b>",
			},
		},
		component: AboTransition,
	},
	{
		section: "abo",
		id: "print",
		hideFor: ["subscribers"],
		props: {
			animationDuration: 1400,
			height: "80vh",
			content: {
				heading: "<b>Der neue<br>Tagesspiegel</b>",
				text: "Aus der Welt.<br>Aus der Weltstadt.<br>30 Tage gratis lesen.",
				button_text: "Jetzt abonnieren",
				button_link: abolinkNachProdukt,
			},
		},
		component: AboPrint,
	},
	{
		section: "abo",
		id: "bestehend",
		hideFor: ["subscribers"],
		props: {
			backgroundFixed: grey,
			height: "auto",
			maxHeight: "none",
			minHeight: "0",
			content: {
				information: {
					heading: "<b>Informationen für Abonnenten und solche, die es werden wollen</b>",
					text: "Muss ich etwas tun, um den neuen Tagesspiegel zu erhalten? Wo finde ich die Ressorts in der neuen Zeitung? Alle Antworten auf einen Blick in unseren&nbsp;FAQ.",
					button_text: "Was ändert sich für mich?",
					button_link: faqlink,
				},
				meinung: {
					heading: "<b>Sie haben Fragen?</b>",
				},
				kontakt: {
					phone: "<b>(030) 290 21-550</b>",
					phone_link: "tel:+493029021550",
					email: "<b>leserservice@tagesspiegel.de</b>",
					email_link: "mailto:leserservice@tagesspiegel.de",
				},
			},
		},
		component: AboBestehend,
	},
	{
		section: "abo",
		id: "transition",
		hideFor: ["default"],
		props: {
			height: "auto",
			maxHeight: "none",
			minHeight: "0",
			background: orange,
			content: {
				// text: "<b>Das ist der neue Tagesspiegel.</b><br>Haben Sie noch Fragen?",
				heading: "<b>Das ist der neue Tagesspiegel.",
				text: "Nehmen Sie sich Zeit, das neue Blatt und das erweiterte Digitalangebot zu erkunden. Viel Vergnügen dabei und herzlichen Dank für Ihre Treue.",
			},
		},
		component: AboTransition,
	},
	{
		section: "abo",
		id: "bestehend",
		hideFor: ["default"],
		props: {
			background: orange,
			backgroundFixed: orange,
			height: "auto",
			maxHeight: "none",
			minHeight: "0",
			content: {
				information: {
					heading: "<b>Informationen für unsere Abonnenten</b>",
					// heading: "<b>Das ist der neue Tagesspiegel.</b>",
					text: "Muss ich etwas tun, um den neuen Tagesspiegel zu erhalten? Wo finde ich die Ressorts in der neuen Zeitung? Alle Antworten auf einen Blick in unseren&nbsp;FAQ.",
					button_text: "Was ändert sich für mich?",
					button_link: faqlink,
				},
				meinung: {
					heading: "<b>Sie haben Fragen?</b>",
				},
				kontakt: {
					phone: "<b>(030) 290 21-550</b>",
					phone_link: "tel:+493029021550",
					email: "<b>leserservice@tagesspiegel.de</b>",
					email_link: "mailto:leserservice@tagesspiegel.de",
				},
			},
		},
		component: AboBestehend,
	},
	{
		section: "abo",
		id: "online",
		hideFor: ["subscribers"],
		props: {
			backgroundFixed: "#fff",
			height: "auto",
			maxHeight: "none",
			minHeight: "0",
			content: {
				heading: "<b>Tagesspiegel online abonnieren</b>",
				text: "Mit Tagesspiegel Plus lesen Sie alle exklusiven Inhalte auf Tagesspiegel.de – in unserer beliebten App stark werbereduziert.",
				button_text: "Unser günstiges Digitalabo",
				button_link: abolinkonline,
			},
		},
		component: AboOnline,
	},
];

cover.props = {
	...cover.props,
};

slides.forEach((s) => {
	s.combinedId = `${s.section}_${s.id}`;
});

export const slidesById = slides.reduce((obj, item) => ({ ...obj, [item.id]: item }), {});
